export const apiWrapper = async ({ fetch, url, options = {} }) => {
  return await new Promise((resolve, reject) => {
    const apiFn = async () => {
      try {
        const response = await fetch(url, options)
        const jsonData = await response.json()
        if (jsonData.error) {
          reject(jsonData.error)
        } else {
          resolve(jsonData)
        }
      } catch(e) {
        reject(e)
      }
    }
    apiFn();
  })
}